import ComponentsFactory from 'foundation/components-factory';
import GtmTriggerComponent from './js/gtm-trigger.component';

ComponentsFactory.getInstance().define('gtm', GtmTriggerComponent);
